var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"menu"},[_c('Menu',{attrs:{"isCollapse":_vm.isCollapse}})],1),_c('div',{class:_vm.isCollapse ? 'small' : 'content'},[_c('div',{staticClass:"box_bgd",attrs:{"title":_vm.isCollapse ? '点击展开' : '点击收起'},on:{"click":_vm.isC}},[_c('i',{class:!_vm.isCollapse
            ? 'iconfont icon-shousuocaidan-copy'
            : 'iconfont icon-shousuocaidan'})]),_c('Content',{attrs:{"is-collapse":_vm.isCollapse}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }